export type ContactType = 'email' | 'tg' | 'discord';

export type ContactItem = {
    type: ContactType;
    value: string;
    url: string;
};

export const CONTACTS_LIST: ContactItem[] = [
    {
        type: 'email',
        value: 'rocketman-streams@proton.me',
        url: 'mailto:rocketman-streams@proton.me',
    },
    {
        type: 'tg',
        value: 'rm_streams_support_bot',
        url: 'https://t.me/rm_streams_support_bot',
    },
    {
        type: 'discord',
        value: 'discord.gg/KXs33hHD6J',
        url: 'https://discord.gg/KXs33hHD6J',
    },
];
